import { Component, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'pc-seat-belt',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: './seat-belt.component.html',
  styleUrl: './seat-belt.component.scss'
})
export class SeatBeltComponent implements OnInit {
  @Input() copy: string = '';
  @Input() buttonText: string = '';
  @Input() buttonUrl: string = '';
  @Input() urlFragment?: string = '';


  ngOnInit(): void {
    // throw new Error('Method not implemented.');
  }

}
